<nav class="border mb-3 px-7 py-2 flex align-middle justify-between bg-primary-500 text-white">
  <ul class="list-none flex">
    <li class="self-center mr-5">
      <a href="/" use:link>Raha rakendus</a>
    </li>
  </ul>
  <ul class="list-none flex">
    <li class="self-center mr-5">{ $userInfo.username }</li>
    <li class="self-center cursor-pointer" on:click="{logout}">
      <Button color="white" text>
        Logi välja
      </Button>
    </li>
  </ul>
</nav>


<script>
  import {userInfo} from '../stores';
  import { push, link } from 'svelte-spa-router';
  import axios from 'axios';
  import ApiService from '../api-service';
  import { Button } from 'smelte';

  async function logout() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    axios.defaults.headers.common['Authorization'] = null;
    
    const response = await ApiService.getCurrentUser();
    userInfo.set(response.data);
    
    push('/login');
  }
</script>